export class ParametrosmastPk {
    companiacodigo: string;
    aplicacioncodigo: string;
    parametroclave: string;
}
export class Parametrosmast {
    pk: ParametrosmastPk;
    constructor() {
        this.pk = new ParametrosmastPk();
    }

    descripcionparametro: string;
    explicacion: string;
    tipodedatoflag: string;
    texto: string;
    numero: number;
    fecha: Date;
    financecomunflag: string;
    estado: string;
    ultimousuario: string;
    ultimafechamodif: Date;

}